import { HStack, Skeleton, VStack } from '@skin-seoul/design-system';
const StatsSectionSkeleton = () => {
  return <HStack width="full" height="100%" gap={3} alignItems="stretch" data-sentry-element="HStack" data-sentry-component="StatsSectionSkeleton" data-sentry-source-file="StatsSection.skeleton.tsx">
      <VStack flex={1} border="1px solid" borderColor="primary.300" background="generic.0" borderRadius="8px" padding={3} alignItems="start" gap={{
      base: 1,
      tablet: 4
    }} data-sentry-element="VStack" data-sentry-source-file="StatsSection.skeleton.tsx">
        <Skeleton height="16px" width="80px" data-sentry-element="Skeleton" data-sentry-source-file="StatsSection.skeleton.tsx" />
        <VStack alignItems="start" gap={1} width="full" data-sentry-element="VStack" data-sentry-source-file="StatsSection.skeleton.tsx">
          <HStack gap={2} alignItems="center" data-sentry-element="HStack" data-sentry-source-file="StatsSection.skeleton.tsx">
            <Skeleton height="36px" width="120px" data-sentry-element="Skeleton" data-sentry-source-file="StatsSection.skeleton.tsx" />
            <Skeleton height="36px" width="36px" borderRadius="4px" data-sentry-element="Skeleton" data-sentry-source-file="StatsSection.skeleton.tsx" />
          </HStack>
          <Skeleton height="20px" width="110px" data-sentry-element="Skeleton" data-sentry-source-file="StatsSection.skeleton.tsx" />
        </VStack>
      </VStack>

      <VStack flex={1} border="1px solid" borderColor="primary.300" background="generic.0" borderRadius="8px" padding={3} alignItems="start" gap={{
      base: 1,
      tablet: 4
    }} data-sentry-element="VStack" data-sentry-source-file="StatsSection.skeleton.tsx">
        <Skeleton height="16px" width="80px" data-sentry-element="Skeleton" data-sentry-source-file="StatsSection.skeleton.tsx" />
        <VStack alignItems="start" gap={1} width="full" data-sentry-element="VStack" data-sentry-source-file="StatsSection.skeleton.tsx">
          <HStack gap={2} alignItems="center" data-sentry-element="HStack" data-sentry-source-file="StatsSection.skeleton.tsx">
            <Skeleton height="36px" width="100px" data-sentry-element="Skeleton" data-sentry-source-file="StatsSection.skeleton.tsx" />
            <Skeleton height="36px" width="36px" borderRadius="4px" data-sentry-element="Skeleton" data-sentry-source-file="StatsSection.skeleton.tsx" />
          </HStack>
          <Skeleton height="20px" width="140px" data-sentry-element="Skeleton" data-sentry-source-file="StatsSection.skeleton.tsx" />
        </VStack>
      </VStack>
    </HStack>;
};
export default StatsSectionSkeleton;